/** Met à jour le hash de l’URL sans déclencher hashchange. */
export function replaceAppHash(hash: string): void {
  const clean = hash.replace(/^#/, '');
  const next = `${window.location.pathname}${window.location.search}#${clean}`;
  if (window.location.hash === `#${clean}`) return;
  history.replaceState(null, '', next);
}
